var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c('SortableItem',{key:item[_vm.itemKey],staticClass:"mb-2",attrs:{"item":item,"item-sorting-key":_vm.itemSortingKey,"max-positions":_vm.maxPositions},on:{"remove":_vm.removeItem,"swap":_vm.swapItem}},[_vm._t("default",null,{"item":item})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }